import SegmentDistribution from "../../components/Insights/distribution/index";
import { connect } from "react-redux";
import {
  setReportWebSiteId,
  getAudienceFilesData,
  getTagAudienceFiles,
  downloadTagAudienceFile,
  setReportDayRange,
  getSegmentDistribution,
  getSegmentReportTop5OS,
  getSegmentDistributionDetailReport,
  getSegmentDistributionDeviceModelReport,
  getSegmentDistributionDeviceTypeReport,
  sendAssistRequest,
  getSegmentDistributionSystems,
  getCultureCodeReport,
  getDistributionHeatMapData,
  setReportGranularity,
} from "../../actions/Insights";
import {
  createScaleAudience,
  clearCreateScaleAudienceInfo,
  createVisitorAudience,
  clearCreateVisitorsAudienceInfo,
} from "../../actions/SegmentCreation";
import { selectClient, getClientInfo } from "../../actions/App";
import { fetchTagDetail } from "../../actions/tags";
import { getClientSites, getClientTags } from "../../actions/Clients";

const mapStateToProps = state => {
  const {
    websiteId,
    dayRange,
    granularity,
    audience_file_data,
    audience_files,
    audience_file_blob,
    tag_info,
    audience_file_error,
    segmentDistributionHouseHold,
    loadingSegmentDistribution,
    top5OSBreakDown,
    loadingTop5OSBreakdown,
    loadingDistributionDetailReport,
    detailDistributionReport,
    loadDeviceModelReport,
    deviceModelReport,
    loadDeviceTypeReport,
    deviceTypeReport,
    send_assist_request_error,
    request_assist_successful,
    savingScaleAudience,
    savingScaleAudienceResult,
    savingScaleAudienceError,
    segmentDistributionSystems,
    savingVisitorsAudienceResult,
    savingVisitorsAudienceError,
    savingVisitorsAudience,
    cultureCodeReport,
    distributionHeatmapData,
    distributionHeatmapLoading,
  } = state.insights;
  const { client_sites, client_tags } = state.clients;
  const { selected_client, clients, client_info } = state.app;
  return {
    websiteId,
    client_info,
    client_sites,
    client_tags,
    selected_client,
    audience_file_data,
    audience_files,
    audience_file_blob,
    audience_file_error,
    tag_info,
    clients,
    dayRange,
    granularity,
    loadingSegmentDistribution,
    segmentDistributionHouseHold,
    top5OSBreakDown,
    loadingTop5OSBreakdown,
    detailDistributionReport,
    loadingDistributionDetailReport,
    loadDeviceModelReport,
    deviceModelReport,
    loadDeviceTypeReport,
    deviceTypeReport,
    send_assist_request_error,
    request_assist_successful,
    location: state.routing.location,
    savingScaleAudience,
    savingScaleAudienceResult,
    savingScaleAudienceError,
    savingVisitorsAudience,
    savingVisitorsAudienceResult,
    savingVisitorsAudienceError,
    segmentDistributionSystems,
    cultureCodeReport,
    distributionHeatmapData,
    distributionHeatmapLoading,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    clearCreateScaleAudienceInfo: () => {
      dispatch(clearCreateScaleAudienceInfo());
    },
    clearCreateVisitorsAudienceInfo: () => {
      dispatch(clearCreateVisitorsAudienceInfo());
    },
    createScaleAudience: (name, tagId, segmentId, dateRange, segments) => {
      dispatch(
        createScaleAudience(name, tagId, segmentId, dateRange, segments),
      );
    },
    createVisitorAudience: (
      name,
      tagId,
      segmentId,
      dateRange,
      segments,
      granularity,
      page,
    ) => {
      dispatch(
        createVisitorAudience(
          name,
          tagId,
          segmentId,
          dateRange,
          segments,
          granularity,
          page,
        ),
      );
    },
    getClientInfo: cid => {
      dispatch(getClientInfo(cid));
    },
    getClientTags: clientId => {
      dispatch(getClientTags(clientId));
    },
    getAudienceFilesData: tagId => {
      dispatch(getAudienceFilesData(tagId));
    },
    setDateRange: str => {
      dispatch(setReportDayRange(str));
    },
    setGranularity: str => {
      dispatch(setReportGranularity(str));
    },
    getTagAudienceFiles: tagId => {
      dispatch(getTagAudienceFiles(tagId));
    },

    getClientSites: cid => {
      dispatch(getClientSites(cid, true));
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
    },

    downloadTagAudienceFile: fileId => {
      dispatch(downloadTagAudienceFile(fileId));
    },

    getTagDetail: (clientId, tagId) => {
      dispatch(fetchTagDetail(clientId, tagId));
    },

    selectClient: clientId => {
      dispatch(selectClient(clientId));
    },

    getSegmentDistribution: (tagId, segment, dateRange, granularity, page) => {
      dispatch(
        getSegmentDistribution(tagId, segment, dateRange, granularity, page),
      );
    },
    getSegmentReportTop5OS: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      granularity,
      page,
    ) => {
      dispatch(
        getSegmentReportTop5OS(
          tagId,
          segment,
          dateRange,
          segmentIds,
          granularity,
          page,
        ),
      );
    },
    getSegmentDistributionDetailReport: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      page,
      granularity,
    ) => {
      dispatch(
        getSegmentDistributionDetailReport(
          tagId,
          segment,
          dateRange,
          segmentIds,
          page,
          granularity,
        ),
      );
    },
    getSegmentDistributionDeviceModelReport: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      granularity,
      page,
    ) => {
      dispatch(
        getSegmentDistributionDeviceModelReport(
          tagId,
          segment,
          dateRange,
          segmentIds,
          granularity,
          page,
        ),
      );
    },
    getSegmentDistributionDeviceTypeReport: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      granularity,
      page,
    ) => {
      dispatch(
        getSegmentDistributionDeviceTypeReport(
          tagId,
          segment,
          dateRange,
          segmentIds,
          granularity,
          page,
        ),
      );
    },
    sendAssistRequest: data => {
      dispatch(sendAssistRequest(data));
    },
    getSegmentDistributionSystems: (tagId, callback) => {
      dispatch(getSegmentDistributionSystems(tagId, callback));
    },
    getCultureCodeReport: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      page,
      granularity,
    ) => {
      dispatch(
        getCultureCodeReport(
          tagId,
          segment,
          dateRange,
          segmentIds,
          page,
          granularity,
        ),
      );
    },
    getDistributionHeatMapData: (
      tagId,
      segment,
      dateRange,
      segmentIds,
      page,
      granularity,
    ) => {
      dispatch(
        getDistributionHeatMapData(
          tagId,
          segment,
          dateRange,
          segmentIds,
          page,
          granularity,
        ),
      );
    },
  };
};

const SegmentDistributionContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SegmentDistribution);

export default SegmentDistributionContainer;



// WEBPACK FOOTER //
// ./src/containers/Insights/SegmentDistribution.js